import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useBrandGuidelines } from "@modules/ECMS/CORPORATE/Forms/MediaCentre/Media.hook";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { fields } from "../../constants";
import { useAirlineIncentives } from "../../BusinessOppurtunities.hook";
import { decodeHTML } from "~/Utils/CommonUtils";
import { corporateHost } from "~/Utils";

export const AirlineIncentivesNextPage = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const { data: airlineIncentivesData, error, isLoading, isError, refetch: useRefetcjAirlineIncentives } = useAirlineIncentives();
  const { data: airlineIncentivesDataById, isLoading: isLoadingCam, refetch: refetchAirlineIncentives } = useDocumentDetails(query?.get("id") || "");

  console.log("brandGuidelines", airlineIncentivesData, airlineIncentivesDataById, query.get('id'));

  useEffect(()=>{
    if(query.get('id')){
      refetchAirlineIncentives();
    } 
    else {
      useRefetcjAirlineIncentives();
    }
  },[])

  const MediaFormConfig: FormConfig = {
    initialValues: {
      field_content_english_description: decodeHTML(
        airlineIncentivesDataById?.payload ? JSON.parse(airlineIncentivesDataById?.payload?.field_content_english)?.data?.description :
        airlineIncentivesData?.[0]?.field_content_english?.data?.description || ""
      ),
      field_content_english_next_page_name: decodeHTML( airlineIncentivesDataById?.payload ? 
        JSON.parse(airlineIncentivesDataById?.payload?.field_content_english)?.data?.nextPage?.name :
        airlineIncentivesData?.[0]?.field_content_english?.data?.nextPage?.name || ""
      ),
      field_content_english_next_page_link: decodeHTML( airlineIncentivesDataById?.payload ? 
        JSON.parse(airlineIncentivesDataById?.payload?.field_content_english)?.data?.nextPage?.link :
        airlineIncentivesData?.[0]?.field_content_english?.data?.nextPage?.link || ""
      ),
      field_content_ms_description: decodeHTML( airlineIncentivesDataById?.payload ? 
        JSON.parse(airlineIncentivesDataById?.payload?.field_content_malay)?.data?.description :
        airlineIncentivesData?.[0]?.field_content_malay?.data?.description || ""
      ),
      field_content_ms_next_page_name: decodeHTML(airlineIncentivesDataById?.payload ? 
        JSON.parse(airlineIncentivesDataById?.payload?.field_content_malay)?.data?.nextPage?.name :
        airlineIncentivesData?.[0]?.field_content_malay?.data?.nextPage?.name || ""
      ),
      field_content_ms_next_page_link: decodeHTML( airlineIncentivesDataById?.payload ? 
        JSON.parse(airlineIncentivesDataById?.payload?.field_content_malay)?.data?.nextPage?.link :
        airlineIncentivesData?.[0]?.field_content_malay?.data?.nextPage?.link || ""
      ),
      field_content_zh_description: decodeHTML(airlineIncentivesDataById?.payload ? 
        JSON.parse(airlineIncentivesDataById?.payload?.field_content_mandarin)?.data?.description :
        airlineIncentivesData?.[0]?.field_content_mandarin?.data?.description || ""
      ),
      field_content_zh_next_page_name: decodeHTML(airlineIncentivesDataById?.payload ? 
        JSON.parse(airlineIncentivesDataById?.payload?.field_content_mandarin)?.data?.nextPage?.name :
        airlineIncentivesData?.[0]?.field_content_mandarin?.data?.nextPage?.name || ""
      ),
      field_content_zh_next_page_link: decodeHTML(airlineIncentivesDataById?.payload ? 
        JSON.parse(airlineIncentivesDataById?.payload?.field_content_mandarin)?.data?.nextPage?.link :
        airlineIncentivesData?.[0]?.field_content_mandarin?.data?.nextPage?.link || ""
      ),
    },    
    fields: fields.airlineIncentivesNextPage,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string

  ) => {
    let excludedKeys: any = [];
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Business Opportunities",
      subModule: `${query?.get("activeTab")}_${query?.get('subActiveTab')}_${query.get('thirdChildActiveTab')}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      moduleKey: "MAHB_CORPORATE_Business Opportunities_Airline Services",
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        id: data?.id || airlineIncentivesData?.[0]?.id || airlineIncentivesDataById?.payload?.id,
        field_content_english: JSON.stringify({
          data: {
            description: data?.field_content_english_description,
            nextPage: {
              name: data?.field_content_english_next_page_name,
              link: data?.field_content_english_next_page_link,
            },
          },
        }),
        field_content_malay: JSON.stringify({
          data: {
            description: data?.field_content_ms_description,
            nextPage: {
              name: data?.field_content_ms_next_page_name,
              link: data?.field_content_ms_next_page_link,
            },
          },
        }),
        field_content_mandarin: JSON.stringify({
          data: {
            description: data?.field_content_zh_description,
            nextPage: {
              name: data?.field_content_zh_next_page_name,
              link: data?.field_content_zh_next_page_link,
            },
          },
        }),
        field_page: airlineIncentivesData?.[0]?.field_page || airlineIncentivesDataById?.payload?.field_page || "",
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };


  return (
    <>
      <DynamicForm
          isLoading={isLoading || isLoadingCam}
          config={MediaFormConfig}
          onSubmit={(data, buttonValue, reviewNotes) =>
            onSubmit(
              data,
              `${corporateHost}/api/page-content/${airlineIncentivesData?.[0]?.id || airlineIncentivesDataById?.payload?.id || '93'}`,
              "UPDATE",
              "PATCH",
              buttonValue == "save" ? "DRAFT" : "PENDING",
              reviewNotes
            )
          }
          defaultReviewNotes="Kindly review this Business Opportunities"
        />
    </>
  );
};
